/**
 * Форматирование строки с экранированными символами в норм строку
 */
Vue.filter('html_entity_decode', (value) => {
    if (!value) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = value.replaceAll('&amp;', '&');
    return txt.value;
});

Vue.filter('format_phone', (value) => {
    if (!value) return '';

    return value.replace(/\d(\d{3})(\d{3})(\d{2})(\d{2})/i, '+7 ($1) $2-$3-$4');
});
